export default __webpack_public_path__ + "static/media/qr_chplay_ikara.a8d32ee4.svg";